// extracted by mini-css-extract-plugin
export default {"messengerBody":"mesengerBody-module__messengerBody___EDHfC","messengerBody__header_spacer":"mesengerBody-module__messengerBody__header_spacer___qmr3A"};